<div class="counts" *ngIf="cclCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >CCL Counts <span>{{ cclCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'cclCounts', 'needsFirstContact']"
      >
        <p class="count">Needs First Contact</p>
        <span>{{ cclCounts.needsFirstContact }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'cclCounts', 'inProgress']"
      >
        <p class="count">In Progress</p>
        <span>{{ cclCounts.inProgress }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'cclCounts', 'needsSurvey']"
      >
        <p class="count">Needs Survey</p>
        <span>{{ cclCounts.needsSurvey }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
